import { TabletTab } from 'components/molecules/TabletTab';
import PreRegisResourceSelect from 'components/organisms/PreRegisResourceSelect';
import ProcessingListContent from 'components/organisms/ProcessingListContent/ProcessingListContent';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import {
  useFetchCompressionResourceInputQuery,
  useRegistInputResourcesMutation,
} from 'apis/compressions_user/compressionUserApi';
import { OperatorType } from 'util/Enums';
import {
  PreRegisSelectedResource,
  ResourcePreRegisFilter,
  SelectedResources,
} from 'util/Types';
import { isError } from 'util/errorHandler';

const InputResourceRegistration = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedResources, setSelectedResources] = useState<SelectedResources>(
    {}
  );
  const [filter, setFilter] = useState<ResourcePreRegisFilter>({});

  const { data: resourceData = [] } = useFetchCompressionResourceInputQuery();
  const [registInputResources] = useRegistInputResourcesMutation();

  const handleSubmitInputRegistration = async (
    values: PreRegisSelectedResource[]
  ) => {
    if (!values.length) return;

    const processingObjectIds = values.map((v) => v.processingObjectId);
    const result = await registInputResources({ processingObjectIds });

    if (isError(result)) return;

    setSelectedResources({});
    toast.success(t('input_resource_registration.regist_success'));
  };

  return (
    <PrimaryTemplate h1={t('input_resource_registration.title')}>
      <TabletTab
        tabItems={[
          t('input_resource_registration.input_registration_tab'),
          t('input_resource_registration.in_process_materials_tab'),
        ]}
        defaultTabIndex={history.location.hash === '#1' ? 1 : 0}
        renderContent={({ index }) => {
          if (index === 0) {
            return (
              <div style={{ padding: '0 24px' }}>
                <PreRegisResourceSelect
                  operatorType={OperatorType.Compressions}
                  resourceData={resourceData}
                  onNext={handleSubmitInputRegistration}
                  submitLabel={t('common.button.input_registration') || ''}
                  actionProps={{
                    selectedResources,
                    setSelectedResources,
                    filter,
                    setFilter,
                  }}
                />
              </div>
            );
          }

          return <ProcessingListContent />;
        }}
      />
    </PrimaryTemplate>
  );
};

export default InputResourceRegistration;
